// extracted by mini-css-extract-plugin
module.exports = {"voterLink":"ProposalVoteHeadline_voterLink__1zFRt","delegateHover":"ProposalVoteHeadline_delegateHover__3LKm0"};